module.exports = __webpack_public_path__ + "viasport-logo-dk-34461f486ba8870697cb480dbe2649a4.png";


//////////////////
// WEBPACK FOOTER
// ./assets/viasport-logo-dk.png
// module id = 1064
// module chunks = 0 1 2